var exports = {
  "Qs": "xfd349460--4cfeb5--content",
  "CS": "xfd349460--4cfeb5--animated",
  "ne": "xfd349460--4cfeb5--controls",
  "Cy": "xfd349460--4cfeb5--controls--with-button",
};

module.exports = exports;
